import { getRgObjectsOfType as n, RG_TYPE as r } from "@project-rouge/rg-core";
const f = (t) => {
  const i = n(t, r.Apartment).length, e = n(t, r.Core).filter((o) => o.data.hasFireLift || o.data.hasNonFireLift).length;
  return e !== 0 ? i / e : 0;
};
export {
  f as getUnitToLiftCoreRatio
};
//# sourceMappingURL=index58.js.map
